import { Theme } from '@mui/material/styles'
import createStyles from '@mui/styles/createStyles'
import makeStyles from '@mui/styles/makeStyles'

type BadgeSize = 'default' | 'compact' | 'micro'
type BadgePlacement = 'bottom-left' | 'top-left' | 'top-right'

interface Props {
  aiGenerated?: boolean
  size?: BadgeSize
  placement?: BadgePlacement
  className?: string
}

const useStyles = makeStyles((theme: Theme) => createStyles({
  badge: {
    alignItems: 'center',
    backgroundColor: 'rgba(17, 24, 39, .9)',
    border: '1px solid rgba(255, 255, 255, .82)',
    borderRadius: 999,
    bottom: theme.spacing(1),
    boxShadow: '0 2px 8px rgba(0, 0, 0, .28)',
    color: '#fff !important',
    display: 'inline-flex',
    fontSize: '.72rem',
    fontStyle: 'normal',
    fontWeight: 800,
    left: theme.spacing(1),
    letterSpacing: '.01em',
    lineHeight: 1,
    padding: theme.spacing(.42, .7),
    pointerEvents: 'none',
    position: 'absolute',
    textTransform: 'uppercase',
    textDecoration: 'none !important',
    whiteSpace: 'nowrap',
    zIndex: 4,
  },
  compact: {
    bottom: 4,
    fontSize: '.6rem',
    left: 4,
    padding: theme.spacing(.3, .48),
  },
  micro: {
    borderRadius: '50%',
    bottom: 1,
    fontSize: '5px',
    height: 13,
    justifyContent: 'center',
    left: 1,
    letterSpacing: '-.25px',
    minWidth: 13,
    padding: 0,
  },
  topLeft: {
    bottom: 'auto',
    top: theme.spacing(1),
  },
  topLeftCompact: {
    bottom: 'auto',
    top: 4,
  },
  topLeftMicro: {
    bottom: 'auto',
    top: 1,
  },
  topRight: {
    bottom: 'auto',
    left: 'auto',
    right: theme.spacing(1),
    top: theme.spacing(1),
  },
  topRightCompact: {
    bottom: 'auto',
    left: 'auto',
    right: 4,
    top: 4,
  },
  topRightMicro: {
    bottom: 'auto',
    left: 'auto',
    right: 1,
    top: 1,
  },
}))

const AiGeneratedBadge: React.FC<Props> = ({
  aiGenerated,
  size = 'default',
  placement = 'bottom-left',
  className,
}) => {
  const classes = useStyles()

  if (!aiGenerated) return null

  const label = size === 'micro' ? 'KI' : 'KI-generiert'

  return <i
    aria-label='KI-generiertes Bild'
    className={[
      classes.badge,
      size === 'compact' ? classes.compact : '',
      size === 'micro' ? classes.micro : '',
      placement === 'top-left' ? classes.topLeft : '',
      placement === 'top-left' && size === 'compact' ? classes.topLeftCompact : '',
      placement === 'top-left' && size === 'micro' ? classes.topLeftMicro : '',
      placement === 'top-right' ? classes.topRight : '',
      placement === 'top-right' && size === 'compact' ? classes.topRightCompact : '',
      placement === 'top-right' && size === 'micro' ? classes.topRightMicro : '',
      className || '',
    ].filter(Boolean).join(' ')}
    data-ai-generated-badge
    title='KI-generiertes Bild'
  >
    {label}
  </i>
}

export default AiGeneratedBadge
